import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const firebaseConfig = {
     apiKey: "AIzaSyBMGs15TTtqIgG44VzYFv6BmAwYokvjSI8",
     authDomain: "mfaproject-354110.firebaseapp.com",
     databaseURL: "https://mfaproject-354110.firebaseio.com",
     projectId: "mfaproject-354110",
     storageBucket: "mfaproject-354110.appspot.com",
     messagingSenderId: "674790428650",
     appId: "1:674790428650:web:95a6573973a34dcd3eec93"
};

/*const firebaseConfig = {
     apiKey: "AIzaSyDNNVVQ3Lr2FsCzkGads6EnM6UGgxNGdBU",
     authDomain: "devmfa-86ca6.firebaseapp.com",
     databaseURL: "https://devmfa-86ca6.firebaseio.com",
     projectId: "devmfa-86ca6",
     storageBucket: "devmfa-86ca6.appspot.com",
     messagingSenderId: "347501324414",
     appId: "1:347501324414:web:aea4d053392d6f124b902f"
};
const firebaseConfig = {
     apiKey: "AIzaSyCcEmf5M3o_eH4KehR2DuUvTMnhQ2jSwpk",
     authDomain: "bintest-6f5f1.firebaseapp.com",
     projectId: "bintest-6f5f1",
     storageBucket: "bintest-6f5f1.appspot.com",
     messagingSenderId: "280908766372",
     appId: "1:280908766372:web:89db352d7534acac5fda31",
     measurementId: "G-3JGNGNC814"
   };*/
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export { auth, db, storage,firebase }